import { colors } from 'pages/new-questions/styles/common';
import styled from 'styled-components';

export const TextArea = styled.textarea`
  width: 100%;
  flex: 1;
  border-radius: 10px;
  padding: 16px 20px;
  border: 1px solid ${colors.lightGray};
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu',
    'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 15px;
  line-height: 1.5;
  resize: vertical;
  min-height: 150px;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: ${colors.primary};
    box-shadow: 0 0 0 3px ${colors.primary}20;
  }

  &::placeholder {
    color: #9ca3af;
  }
`;
